import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const  MyVerticallyCenteredModal =(props)=> {
    return (
      <Modal
        {...props}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton className='border-0 py-0'>
          <Modal.Title className="ms-auto" id="contained-modal-title-vcenter" >
            {props.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='justify-content-center d-flex'>
          <img src={props.imageLink} alt="Modal Content" />
        </Modal.Body>
      </Modal>
    );
  }
  
  export default MyVerticallyCenteredModal